<template>
    <div class="v-labeled-checkbox" :class="{'v-labeled-checkbox--checked': state}">

        <div class="v-labeled-checkbox__checkbox">
            <v-checkbox
                    :id="id"
                    :val="val"
                    :value="value"
                    :name="name"
                    @input="$emit('input', $event)"
            >
            </v-checkbox>
        </div>

        <label :for="id" class="v-labeled-checkbox__label">
            {{ label }}
        </label>
    </div>


</template>

<script>
    import vCheckbox from "./vCheckbox"

    export default {
        name: "labeled-checkbox",
        props: {
            value: {type: [Boolean, Array], default: false},
            val: {type: String, default: ""},
            name: {type: String, default: ""},
            label: {type: String, default: ""},
            id: {type: String, default: ""},
        },
        computed: {
            state() {
                console.log(typeof this.value);
                if (typeof this.value == "boolean") {
                    return this.value;
                } else {
                    return this.value.indexOf(this.val) !== -1;
                }
            }
        },
        components: {
            vCheckbox
        }
    }
</script>

<style lang="scss">


    //noinspection CssUnknownTarget
    @import '~@/scss/main.scss';

    .v-labeled-checkbox {

        display: flex;
        align-items: flex-start;
        justify-content: flex-start;

        &__checkbox{
            padding-top: .15em;
            width: 1.5em;
            height: 1.5em;
            flex: none;
        }

        &__label {
            cursor: pointer;
            margin-left: .5em;
        }

        &--checked {
            .v-labeled-checkbox__label {
                color: $primary-color;
            }

        }

    }
</style>